import { render, staticRenderFns } from "./platformWithdrawal.vue?vue&type=template&id=920c9c8c&scoped=true"
import script from "./platformWithdrawal.vue?vue&type=script&lang=js"
export * from "./platformWithdrawal.vue?vue&type=script&lang=js"
import style0 from "./platformWithdrawal.vue?vue&type=style&index=0&id=920c9c8c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "920c9c8c",
  null
  
)

export default component.exports